<div class="cart-column-spacing my-cart-listing white-bg">
    <div class="product-grid">
        <div class="my-cart-header mt-4" *ngIf="componentLoaded">
            <h3 class="d-none d-lg-flex">My Cart</h3>
            <div class="remove-part">
                <span [ngClass]="{'remove-all':true, 'empty':totalProductCount1 == 0?true : false}">
                    <a href="javascript:void(0)" *ngIf="productList1.length != 0 || productList2.length != 0"
                        (click)="removePopup(cartTemplate, 'All', '', '');">
                        <svg class="mr-2" xmlns="http://www.w3.org/2000/svg" width="27" height="27" viewBox="0 0 27 27">
                            <g fill="none" fill-rule="evenodd">
                                <g>
                                    <g>
                                        <g>
                                            <g>
                                                <g>
                                                    <g
                                                        transform="translate(-1320 -1005) translate(15 972) translate(30 30) translate(1275 3)">
                                                        <rect width="26.615" height="26.615" fill="#FFF3F3"
                                                            rx="12.313" />
                                                        <g fill="#D9394C" fill-rule="nonzero">
                                                            <path
                                                                d="M10.037 3.825c.429 0 .841.181 1.132.497.29.316.436.742.4 1.17l-.711 8.48c-.033.385-.207.742-.492 1.003-.284.262-.654.406-1.04.406H2.536c-.387 0-.756-.144-1.04-.406-.285-.261-.46-.618-.492-1.003l-.712-8.48c-.035-.428.11-.854.4-1.17.291-.316.704-.497 1.133-.497h8.21zm0 1.145H1.826c-.11 0-.215.046-.29.127-.074.08-.11.19-.102.299l.712 8.48c.017.202.189.36.391.36h6.788c.203 0 .375-.158.392-.36l.711-8.48c.01-.11-.028-.218-.102-.299-.074-.08-.18-.127-.29-.127zM3.36 6.575c.317-.02.588.22.61.533l.324 4.915c.02.315-.219.588-.534.609l-.038.001c-.3 0-.55-.235-.57-.535l-.325-4.914c-.01-.153.04-.3.14-.415.101-.115.24-.184.393-.194zm2.571-.001c.316 0 .573.256.573.572v4.915c0 .315-.257.572-.573.572-.315 0-.572-.257-.572-.572V7.146c0-.316.257-.572.572-.572zm2.571 0c.153.01.292.08.393.195.1.115.15.262.14.415l-.324 4.914c-.02.3-.27.535-.57.535l-.039-.001c-.315-.021-.554-.294-.533-.61l.324-4.914c.021-.312.292-.554.61-.533zM7.734 0c.848 0 1.538.69 1.538 1.538v.564h2.018c.316 0 .572.257.572.572 0 .316-.256.573-.572.573H.572C.257 3.247 0 2.99 0 2.674c0-.315.257-.572.572-.572h2.019v-.564C2.591.69 3.281 0 4.129 0h3.605zm0 1.145H4.129c-.217 0-.393.176-.393.393v.539h4.39v-.54c0-.216-.176-.392-.392-.392z"
                                                                transform="translate(7.604 5.07)" />
                                                        </g>
                                                    </g>
                                                </g>
                                            </g>
                                        </g>
                                    </g>
                                </g>
                            </g>
                        </svg>

                        Remove All</a></span> <span *ngIf="productList1.length != 0"
                    class="product-count">{{totalProductCount1}} Products</span>
            </div>
        </div>

        <div class="my-cart-listing white-bg">

            <div class="product-grid">
                <div class="auto-add new-design-main" id="productrecmcart_{{recommendation.recommend_id}}"
                    *ngFor="let recommendation of recommendedProducts">
                    <div class="auto-add-detail new-design-customer">
                        <div class="user-image">
                            <img *ngIf="recommendation.salesrep_image == '' || recommendation.salesrep_image == null"
                                class="rounded" src="../../assets/images/Group-742a.png" alt="user-pic">
                            <img *ngIf="recommendation.salesrep_image != '' && recommendation.salesrep_image != null"
                                class="rounded" src="{{profileImagePath}}{{recommendation.salesrep_image}}"
                                alt="user-pic">
                        </div>
                        <div class="added-quantity" *ngIf="recommendation.sales_rep_name != ''">
                            <h2>{{recommendation.recommendation_name}} | {{recommendation.sales_rep_name}}
                                <span>({{recommendation.total_products}})</span>
                            </h2>
                        </div>

                        <div class="recommended-mesage">
                            {{recommendation.recommendation_message}}
                        </div>

                        <button type="button" class="info-tool d-none"
                            tooltip="{{recommendation.recommendation_message}}">
                            <img src="../../../../assets/images/wos_web_info.svg" alt="" triggers="focus"></button>


                    </div>
                    <div *ngIf="!noRecord2" class="infinite-responsive scroll-body" infiniteScroll
                        [infiniteScrollDistance]="1" [infiniteScrollThrottle]="50" (scrolled)="onScrollDown2()"
                        [scrollWindow]="false">
                        <div class="product-wrapper with-tags only-for-srp-products" id="product_{{product.product_id}}"
                            *ngFor="let product of recommendation.products">
                            <ul class="product-type" *ngIf="product.price_marked == 1">
                                <li>
                                    <img src="../../assets/images/pmp.svg" class="pmp-image" width="40"
                                        alt="checked icon" />
                                </li>
                            </ul>
                            <div class="product-image">
                                <a [routerLink]="['/product/detail',product.sku]">
                                    <img src="{{imagePath}}{{product?.images[0]}}" alt="">
                                </a>
                            </div>
                            <div class="product-description">
                                <div class="product-detail-block">
                                    <a routerLink="/product/detail/{{product.sku}}">
                                        <h2>{{product.short_desc}}</h2>
                                    </a>
                                    <ul class="product-code">
                                        <li>{{product.barcode}}</li>
                                        <li class="seperator">|</li>
                                        <li>{{product.sku}}</li>
                                    </ul>
                                    <div class="stock mt-2" *ngIf="product.is_in_stock == 1">
                                        <img src="../../assets/images/in-stock-icon.svg" alt="in-stock-icon">
                                        In Stock
                                    </div>
                                </div>

                                <ul class="order-quantity-details">
                                    <li>
                                        <span>RSP</span>
                                        <p> <span class="text-dark"
                                                *ngIf="product.rsp !== '0.00'">£{{product.rsp}}</span>
                                            <span class="text-dark" *ngIf="product.rsp == '0.00'">N/A</span>
                                            <span
                                                *ngIf="product.rsp != '0.00' && (product.sale_unit != '' && (product.sale_unit == 'Kilo' || product.sale_unit == 'Each'))">per
                                                100g</span>
                                            <span
                                                *ngIf="product.rsp != '0.00' && (product.sale_unit != '' && product.sale_unit.indexOf('C') !== -1)">each</span>
                                        </p>
                                    </li>
                                    <li *ngIf="global_data?.margin_visibility == 1">
                                        <span>Margin</span>
                                        <p><span class="text-dark">{{product.margin}}%</span></p>
                                    </li>
                                    
                                    
                                    <li *ngIf="global_data?.price_visibility == 1">
                                        <span>Cost</span>
                                        <p><strong>£{{product.price}}</strong></p>
                                    </li>
                                    <li>
                                        <span>Case</span>
                                        <p><strong>{{product.size_case}}</strong></p>
                                    </li>

                                </ul>

                                <div class="spinner-and-price">
                                    <div class="spinner" id="spinner_{{product.product_id}}">
                                        <ngx-number-spinner id="spinerbtn_{{product.product_id}}"
                                            [value]="product.item_qty !='' ? toInteger(product.item_qty) : 1" [min]="0"
                                            (change)="qytUpdate(product, $event, '', removeFromcartTemplate, recommendation.recommend_id)">
                                        </ngx-number-spinner>
                                    </div>
                                    <div class="total-price" *ngIf="global_data?.price_visibility == 1">
                                        £{{product.row_total}}
                                    </div>
                                </div>

                                <div class="delete-product">
                                    <a href="javascript:void(0);"
                                        (click)="removePopup(cartTemplate, 'list2', product,recommendation.recommend_id);"
                                        title="Delete product">
                                        <img src="../../assets/images/delete.svg" alt="delete">
                                    </a>
                                </div>

                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
        <div class="product-wrapper px-0 py-4" id="productcart_{{product.product_id}}"
            *ngFor="let product of productList1">
            <ul class="product-type" *ngIf="product.price_marked == 1">
                <li>
                    <img src="../../assets/images/pmp.svg" class="pmp-image" alt="checked icon" />
                </li>
            </ul>
            <div class="product-image">
                <a [routerLink]="['/product/detail',product.sku]">
                    <img src="{{imagePath}}{{product?.images[0]}}" alt="">
                </a>
            </div>
            <div class="product-description">
                <div class="product-detail-block">
                    <a [routerLink]="['/product/detail',product.sku]">
                        <h2>{{product.short_desc}}</h2>
                    </a>
                    <ul class="product-code">
                        <li>{{product.barcode}}</li>
                        <li class="seperator">|</li>
                        <li>{{product.sku}}</li>
                    </ul>
                </div>

                <ul class="order-quantity-details">
                    <li>
                        <span>RSP</span>
                        <p> <span class="text-dark" *ngIf="product.rsp !== '0.00'">£{{product.rsp}}</span>
                            <span class="text-dark" *ngIf="product.rsp == '0.00'">N/A</span>
                            <span
                                *ngIf="product.rsp != '0.00' && (product.sale_unit != '' && (product.sale_unit == 'Kilo' || product.sale_unit == 'Each'))"
                                class="each">per 100g</span>
                            <span
                                *ngIf="product.rsp != '0.00' && (product.sale_unit != '' && product.sale_unit.indexOf('C') !== -1)"
                                class="each">each</span>
                        </p>
                    </li>
                    <li *ngIf="global_data?.margin_visibility == 1">
                        <span>Margin</span>
                        <p><span class="text-dark">{{product.margin}}%</span></p>
                    </li>
                    
                    <li *ngIf="global_data?.price_visibility == 1">
                        <span>Cost</span>
                        <p><strong>£{{product.price}}</strong></p>
                    </li>
                    <li>
                        <span>Case</span>
                        <p><strong>{{product.size_case}}</strong></p>
                    </li>
                </ul>
                <div class="spinner-and-price">
                    <div class="spinner" id="spinnercart1_{{product.product_id}}">
                        <ngx-number-spinner id="spinerbtncart1_{{product.product_id}}"
                            [value]="product.item_qty !='' ? toInteger(product.item_qty) : 1" [min]="0"
                            (change)="qytUpdate(product, $event, 'list1', removeFromcartTemplate,'')">
                        </ngx-number-spinner>
                    </div>

                    <div class="total-price" *ngIf="global_data?.price_visibility == 1">
                        £{{product.row_total}}
                    </div>
                </div>


                <div class="delete-product">
                    <a href="javascript:void(0);" (click)="removePopup(cartTemplate, 'list1', product, '');"
                        title="Delete product">
                        <img src="../../assets/images/delete.svg" alt="delete">
                    </a>
                </div>

            </div>
        </div>
        <div class="view-all-order d-flex view-all-cart"><a href="javascript:void(0);" (click)="onScrollDown1()"
                *ngIf="(this.nextPage1 != 1 && this.nextPage1 !== null) && !this.loading1" title="View More"
                class="btn primary-btn">View More</a></div>

        <div class="row no-result"
            *ngIf="productList1.length == 0 && recommendedProducts.length == 0 && componentLoaded && checkIfAllDataLoaded">
            <div class="col-12">
                <div class="no-result-content">
                    <img src="../../assets/images/no-result.svg" alt="no-result">
                    <p>Sorry, no results found!</p>
                    <span>We couldn’t find what you’re looking for</span>
                </div>
            </div>
        </div>
        <div class="row no-result"
            *ngIf="productList1.length == 0 && productList2.length == 0 && !checkIfAllDataLoaded">
            <div class="col-12">
                <div class="no-result-content text-center">
                    <img src="../../assets/images/hourglass-shb.svg" alt="no-result">
                    <p>Loading...</p>
                </div>
            </div>
        </div>

    </div>
</div>

<ng-template #cartTemplate>
    <div class="modal-header border-0 pb-2">
        <h4 class="modal-title">Confirmation!</h4>
        <button type="button" class="close  " aria-label="Close" (click)="bsModalRef.hide()">
            <span aria-hidden="true"><svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" viewBox="0 0 16 16">
                    <g fill="none" fill-rule="evenodd">
                        <g stroke="#9B9B9B" stroke-width="1.75">
                            <g>
                                <g>
                                    <path d="M14 0L0 14M0 0L14 14"
                                        transform="translate(-1190 -462) translate(695 443) translate(496 20)" />
                                </g>
                            </g>
                        </g>
                    </g>
                </svg></span>
        </button>
    </div>
    <div class="modal-body py-0 px-0">
        <div class="row">
            <div class="col-md-12">
                <div class="text-center">
                    <p>{{removeHeading}}</p>
                </div>
                <div class="button-div text-center mt-3">
                    <button class="common-button mr-3" (click)="bsModalRef.hide()">Cancel</button>
                    <button class="common-button ghost" *ngIf="removeType != ''"
                        (click)="removeItem(removeProduct, selectedRecommendation)">Confirm</button>
                    <button class="common-button ghost" *ngIf="removeType == ''" (click)="clearCart()">Confirm</button>
                </div>
            </div>
        </div>
    </div>
</ng-template>

<ng-template #removeFromcartTemplate>
    <div class="modal-header border-0 pb-2">
        <h4 class="modal-title">Confirmation!</h4>
        <button type="button" class="close  " aria-label="Close"
            (click)="cancleRequest(removeProduct, selectedRecommendation)">
            <span aria-hidden="true"><svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" viewBox="0 0 16 16">
                    <g fill="none" fill-rule="evenodd">
                        <g stroke="#9B9B9B" stroke-width="1.75">
                            <g>
                                <g>
                                    <path d="M14 0L0 14M0 0L14 14"
                                        transform="translate(-1190 -462) translate(695 443) translate(496 20)" />
                                </g>
                            </g>
                        </g>
                    </g>
                </svg></span>
        </button>
    </div>
    <div class="modal-body py-0 px-0">
        <div class="row">
            <div class="col-md-12">
                <div class="text-center">
                    <p>Are you sure you want to remove product from cart?</p>
                </div>
                <div class="button-div text-center mt-3">
                    <button class="common-button mr-3"
                        (click)="cancleRequest(removeProduct, selectedRecommendation)">Cancel</button>
                    <button class="common-button ghost"
                        (click)="removeItem(removeProduct, selectedRecommendation)">Confirm</button>
                </div>
            </div>
        </div>
    </div>
</ng-template>